import axios from 'axios';
import config from '../Config';
import authHeader from './auth-header';

const API_URL = config.API_URL;
const API_VERSION = config.API_VERSION;

const getJobWork = () => {
    try {
        return axios.get(`${API_URL}/api/${API_VERSION}/job-work/`, {
            headers: authHeader(),
        });
    } catch (error) {
        console.error('Error fetching job work list:', error);
        throw error;
    }
};
const createJobWork = workorderId => {
    try {
        return axios.post(
            `${API_URL}/api/${API_VERSION}/workorder/create-jobwork/?workorder_id=${workorderId}`,
            {},
            {
                headers: authHeader(),
            },
        );
    } catch (error) {
        console.error('Error fetching job work list:', error);
        throw error;
    }
};

const jobWorkService = {
    getJobWork,
    createJobWork,
};

export default jobWorkService;